var moduleMap = {
	"./useHubRoutes": function() {
		return Promise.all(/* __federation_expose_useHubRoutes */[__webpack_require__.e(5534), __webpack_require__.e(7096)]).then(function() { return function() { return (__webpack_require__(3566)); }; });
	},
	"./useTelevetRoutes": function() {
		return Promise.all(/* __federation_expose_useTelevetRoutes */[__webpack_require__.e(5534), __webpack_require__.e(7096)]).then(function() { return function() { return (__webpack_require__(3566)); }; });
	},
	"./useFormattedTelevetRoutes": function() {
		return Promise.all(/* __federation_expose_useFormattedTelevetRoutes */[__webpack_require__.e(497), __webpack_require__.e(3236), __webpack_require__.e(7452), __webpack_require__.e(1167), __webpack_require__.e(9740), __webpack_require__.e(3560), __webpack_require__.e(110), __webpack_require__.e(4672), __webpack_require__.e(720), __webpack_require__.e(4036), __webpack_require__.e(2586), __webpack_require__.e(9962), __webpack_require__.e(3732), __webpack_require__.e(8122), __webpack_require__.e(1995), __webpack_require__.e(5534), __webpack_require__.e(1682), __webpack_require__.e(9138)]).then(function() { return function() { return (__webpack_require__(3594)); }; });
	},
	"./useMostViewedTelevetRoutes": function() {
		return Promise.all(/* __federation_expose_useMostViewedTelevetRoutes */[__webpack_require__.e(497), __webpack_require__.e(3236), __webpack_require__.e(7452), __webpack_require__.e(1167), __webpack_require__.e(9740), __webpack_require__.e(3560), __webpack_require__.e(110), __webpack_require__.e(4672), __webpack_require__.e(720), __webpack_require__.e(4036), __webpack_require__.e(2586), __webpack_require__.e(9962), __webpack_require__.e(3732), __webpack_require__.e(8122), __webpack_require__.e(1995), __webpack_require__.e(5534), __webpack_require__.e(1682), __webpack_require__.e(5923)]).then(function() { return function() { return (__webpack_require__(5187)); }; });
	},
	"./TelevetProductSection": function() {
		return Promise.all(/* __federation_expose_TelevetProductSection */[__webpack_require__.e(497), __webpack_require__.e(3236), __webpack_require__.e(7452), __webpack_require__.e(1167), __webpack_require__.e(9740), __webpack_require__.e(3560), __webpack_require__.e(110), __webpack_require__.e(4672), __webpack_require__.e(720), __webpack_require__.e(5620), __webpack_require__.e(4036), __webpack_require__.e(2586), __webpack_require__.e(9962), __webpack_require__.e(8486), __webpack_require__.e(9172), __webpack_require__.e(3732), __webpack_require__.e(8122), __webpack_require__.e(1995), __webpack_require__.e(5534), __webpack_require__.e(1682), __webpack_require__.e(865), __webpack_require__.e(5935)]).then(function() { return function() { return (__webpack_require__(8765)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});